import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import StyleProvider from './style/StyleProvider.tsx';
import { ReactFlowProvider } from 'reactflow';

import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: 'https://f9dab98487d0f26a4690c260a7be3076@o4507492530782208.ingest.de.sentry.io/4507589170692176',
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<StyleProvider>
			<ReactFlowProvider>
				<App />
			</ReactFlowProvider>
		</StyleProvider>
	</React.StrictMode>,
);
